import axios from 'axios';
import config from 'config';

const ROOT = config.IMAGE_BASE_URL;

class ContentService {

    static getMyEnterpriseLogo() {
        return this.call(`${ROOT}enterprises/logos?ts=${Date.now()}`); 
    }

    static getEnterpriseLogo(token) {
        return this.call(`${ROOT}enterprises/logos/${token}.png`);
    }

    static getEntityImage(imageUrl) {
        return this.call(imageUrl);
    }

    static getDeviceGroupingImage(groupingId, imageName) {
        return this.call(`${ROOT}groupings/${groupingId}/images/${imageName}`);
    }

    static getDeviceGroupingFloorplanImage(groupingId) {
        return this.call(`${ROOT}groupings/${groupingId}/images/floorplan`);
    }

    static getAssetImage(assetId, imageName) {
        return this.call(`${ROOT}assets/${assetId}/images/${imageName}`);
    }

    static getSecureStaticResource(url) {
        return new Promise((resolve, reject) => {
            axios.get(url).then(response => {
                resolve({signedURL: response.data});
            }).catch(err => {
                reject(err);
            })
        })
    }

    static call(uri) {
        return new Promise((resolve, reject) => {
            axios.get(uri).then(response => {
                resolve(response.data);
            }).catch(err => {
                console.error(err);
                resolve(`${config.WEB_BASE_URL}/images/icon/no_image_icon.svg`);
            });
        });
    }
}

export default ContentService;
